/*************************************************/
/* SLIMSY                                        */
/*************************************************/
import 'lazysizes';
lazySizes.cfg.preloadAfterLoad = true;